export interface ChatMessageVO {
  content: string;
  id?: string;
  roomId?: string;
  instant: number;
  receiver: string;
  receiverHash: string;
  sender?: string;
  senderHash?: string;
  viewed?: boolean;
  inviteInfo?: {
    id: string;
    clientName: string;
    clientUsername: string;
  };
}

export const emptyChatMessage = (): ChatMessageVO => ({
  content: '',
  id: '',
  roomId: '',
  instant: new Date().getTime(),
  receiver: '',
  receiverHash: '',
  sender: '',
  senderHash: '',
});

export interface ChatMessageListVO {
  archived: boolean;
  chats: {
    content: ChatMessageVO[];
    offset: number;
    limit: number;
    total: number;
  };
  ids: string[];
  notFirstLoad?: boolean;
}

export const emptyChatMessageList = (): ChatMessageListVO => ({
  archived: false,
  chats: {
    content: [],
    offset: 0,
    limit: 30,
    total: 0,
  },
  ids: [],
});
